import React, { useEffect, useState } from "react";
import { Image } from "@react-pdf/renderer";
import { generateQRBase64 } from "../../../../utils/qrcodeBase64";

const PDFQRCode = ({ value }) => {

  const [qr, setQR] = useState(null);

  useEffect(() => {
    const loadQR = async () => {
      const img = await generateQRBase64(value);
      setQR(img);
    };

    loadQR();
  }, [value]);

  if (!qr) return null;

  return (
    <Image
      src={qr}
      style={{
        width: 110,
        height: 110
      }}
    />
  );
};

export default PDFQRCode;